import boletaApi from "./boletaApi";

export const updateInvoiceStatus = async (
  idInvoice,
  newStatus,
  interesFlag,
  metaData,
  detail
) => {
  try {
    return await boletaApi.post("/updateInvoiceStatus", {
      idInvoice,
      newStatus,
      interesFlag,
      metaData,
      detail,
    });
  } catch (error) {
    const { response } = error;
    return response;
  }
};
